<app-admin-dashboard>
  <div class="card">
    <span class="text-sm font-normal module-title">
      {{'AdminOrderManagement.ModuleTitle' | translate}}
    </span>
    <div class="mb-3"></div>

    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <span *ngIf="isProgram === true" class="text-xl font-medium text-800">
          {{'AdminOrderManagement.ProgramPageTitle' | translate}}
        </span>
        <span *ngIf="!isProgram" class="text-xl font-medium text-800">
          {{'AdminOrderManagement.OrdersPageTitle' | translate}}
        </span>
      </div>
      <div class="w-9 flex align-items-center justify-content-start flex-wrap">
        <span class="p-input-icon-left justify-content-start flex w-6">
          <i class="pi pi-search custom-input-icon"></i>
          <input [(ngModel)]="searchTerm" (input)="changeFilter()" type="text" pInputText
            placeholder="{{'AdminOrderManagement.SearchInput' | translate}}"
            class="p-inputtext-sm custom-input bg-form w-full" />
        </span>
      </div>
    </div>

    <div class="body-card">
      <form [formGroup]="filterForm">
        <div class="flex flex-row justify-content-between flex-wrap align-items-center align-content-center py-3">
          <div class="flex flex-row">
            <div class="container-select">
              <p-dropdown
                formControlName="orderId"
                placeholder="{{'AdminOrderManagement.Table.OrderIdColumn' | translate}}"
                [options]="ordersFilter"
                (onChange)="changeFilter()"
                (onClear)="changeFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div *ngIf="isProgram === true" class="container-select">
              <p-dropdown
                formControlName="programId"
                placeholder="{{'AdminOrderManagement.Table.ProgramIdColumn' | translate}}"
                [options]="programsFilter"
                (onChange)="changeFilter()"
                (onClear)="changeFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="specie"
                placeholder="{{'AdminOrderManagement.Table.SpecieColumn' | translate}}"
                [options]="speciesFilter"
                (onChange)="changeFilter()"
                (onClear)="changeFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="variety"
                placeholder="{{'AdminOrderManagement.Table.VarietyColumn' | translate}}"
                [options]="varietiesFilter"
                (onChange)="changeFilter()"
                (onClear)="changeFilter()"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-12rem"
              />
            </div>

            <div class="container-select">
              <p-dropdown
                formControlName="status"
                optionLabel="label"
                optionValue="value"
                placeholder="{{'AdminOrderManagement.Table.StatusColumn' | translate}}"
                [options]="statusFilter"
                (onChange)="onFilterStatus()"
                (onClear)="onFilterStatus()"
                [showClear]="false"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [autoDisplayFirst]="false"
                class="custom-dropdown bg-form"
                styleClass="w-14rem"
              />
            </div>

            <!-- <div class="">
              <p-button
                (onClick)="clearFilters()"
                styleClass="p-button-sm p-button-primary" class="clear-filter-button"
                label="{{'AdminOrderManagement.ClearFilterBtn' | translate}}"
              />
            </div> -->
          </div>
        </div>

      </form>

      <p-table
        #dt
        [value]="filteredOrders"
        dataKey="importOrder.id"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loading"
        class="order-table"
        [totalRecords]="totalCount"
        (onLazyLoad)="changePage($event)"
        [lazy]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
      >
        <ng-template pTemplate="header">
          <tr>
            <th id="orderId" class="w-6rem">
              <div class="cell-style flex-row">
                <div class="flex flex-column">
                  <span *ngIf="isProgram === true">{{ 'AdminOrderManagement.Table.ProgramIdColumn' | translate }}/</span>
                  <span>{{ 'AdminOrderManagement.Table.OrderIdColumn' | translate }}</span>
                </div>
              </div>
            </th>
            <th id="programName" class="w-6rem">
              <div class="cell-style flex-row">
                <div class="flex flex-column">
                  <span *ngIf="isProgram === true">{{ 'AdminOrderManagement.Table.ProgramNameColumn' | translate }}</span>
                </div>
              </div>
            </th>
            <th id="importer">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.ImporterColumn' | translate }}
                <p-columnFilter
                  field="importOrder.importer.companyName" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-1 pb-0">
                      <span class="filter-title">{{ 'AdminOrderManagement.Table.ImporterColumn' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown
                      [ngModel]="value"
                      [options]="importersFilter"
                      (onChange)="filter($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterBy="label"
                      [autoDisplayFirst]="false"
                      class="input-custom"
                    />
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th id="exporter">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.ExporterColumn' | translate }}
                <p-columnFilter
                  field="exporterName" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-1 pb-0">
                      <span class="filter-title">{{ 'AdminOrderManagement.Table.ExporterColumn' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown
                      [ngModel]="value"
                      [options]="exportersFilter"
                      (onChange)="filter($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterBy="label"
                      [autoDisplayFirst]="false"
                      class="input-custom"
                    />
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th id="container">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.ContainerColumn' | translate }}
                <p-columnFilter
                  field="containerNumber" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-1 pb-0">
                      <span class="filter-title">{{ 'AdminOrderManagement.Table.ContainerColumn' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown
                      [ngModel]="value"
                      [options]="containersFilter"
                      (onChange)="filter($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterBy="label"
                      [autoDisplayFirst]="false"
                      class="input-custom"
                    />
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th id="instructive">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.InstructiveColumn' | translate }}
                <p-columnFilter
                  field="instructive" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-1 pb-0">
                      <span class="filter-title">{{ 'AdminOrderManagement.Table.InstructiveColumn' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown
                      [ngModel]="value"
                      [options]="instructivesFilter"
                      (onChange)="filter($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterBy="label"
                      [autoDisplayFirst]="false"
                      class="input-custom"
                    />
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th id="ship">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.ShipColumn' | translate }}
                <p-columnFilter
                  field="ship" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-1 pb-0">
                      <span class="filter-title">{{ 'AdminOrderManagement.Table.ShipColumn' | translate }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown
                      [ngModel]="value"
                      [options]="shipsFilter"
                      (onChange)="filter($event.value)"
                      optionLabel="label"
                      optionValue="value"
                      [filter]="true"
                      filterBy="label"
                      [autoDisplayFirst]="false"
                      class="input-custom"
                    />
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th id="specie">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.SpecieColumn' | translate }}
              </div>
            </th>
            <th id="booking">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.BookingColumn' | translate }}
              </div>
            </th>
            <th id="voyageNumber">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.VoyageNumberColumn' | translate }}
              </div>
            </th>
            <th id="created">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.CreatedDateColumn' | translate }}
                <p-columnFilter
                  type="date" field="importOrder.created" display="menu" matchMode="contains"
                  [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"/>
              </div>
            </th>
            <th id="time" class="w-7rem">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.TimeColumn' | translate }}
              </div>
            </th>
            <th id="status">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.StatusColumn' | translate }}
              </div>
            </th>
            <th id="action">
              <div class="cell-style">
                {{ 'AdminOrderManagement.Table.ActionsColumn' | translate }}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
          <tr>
            <td>
              <div class="cell-style w-7rem">
                <span *ngIf="isProgram === true">{{order.importOrder.directSaleProgramId}}/</span>
                {{order.importOrder.sequence}}
              </div>
            </td>
            <td>
              <div class="cell-style w-7rem">
                <span *ngIf="isProgram === true">{{order.importOrder.directSaleProgram.name}}</span>
              </div>
            </td>
            <td>
              <div class="cell-style font-semibold">{{order.importOrder.importer.companyName}}</div>
            </td>
            <td>
              <div class="cell-style font-semibold">{{order.exporterName}}</div>
            </td>
            <td>
              <div class="cell-style">{{order.containerNumber}}</div>
            </td>
            <td>
              <div class="cell-style">{{order.instructive}}</div>
            </td>
            <td>
                <div class="cell-style">{{order.ship}}</div>
            </td>
            <td class="text-center">
              <div class="cell-style text-center justify-content-center">
                <div *ngIf="order.genericDetails?.length > 0">
                  <ng-container *ngFor="let d of order.genericDetails">
                    <div class="flex flex-column">
                      <span>{{d | speciesName}}</span>
                      <span>{{d.varietyName}}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </td>
            <td>
              <div class="cell-style">{{order.delivery.booking}}</div>
            </td>
            <td>
              <div class="cell-style">{{order.delivery.voyageNumber}}</div>
            </td>
            <td>
              <div class="cell-style text-left justify-content-start">
                {{order.importOrder.created | date: 'dd-MM-yyyy HH:mm'}}
              </div>
            </td>
            <td>
              <div *ngIf="selectedStatus.value === 'PendingVerifyPallets'"
                class="cell-style flex-column w-7rem">
                <span>{{ 'AdminOrderManagement.Table.ConfirmBefore' | translate }}</span>
                <app-timer
                  [orderDateTarget]="order.importOrder.pendingPalletDate"
                  [showSeconds]="false"
                  [isShortText]="true"
                />
              </div>
              <div *ngIf="selectedStatus.value === 'ImporterOrderConfirmed,ImporterPaymentConfirmed' && order.importOrder?.status === 3"
                class="cell-style flex-column w-7rem">
                <span>{{ 'AdminOrderManagement.Table.ConfirmBefore' | translate }}</span>
                <app-timer
                  [orderDateTarget]="order.importOrder.pendingPaymentDate"
                  [showSeconds]="false"
                  [isShortText]="true"
                />
              </div>
            </td>
            <td>
              <div class="cell-style">
                <span [ngClass]="selectedStatus.styleClass" class="status-text">
                  {{ selectedStatus.label }}
                </span>
              </div>
            </td>
            <td>
              <div class="cell-style gap-2">
                <p-button icon="pi pi-eye"
                  styleClass="p-button-rounded p-button-text" class="action-btn custom-btn eye-icon"
                  pTooltip="{{ 'AdminOrderManagement.Table.SeeOrderDetail' | translate }}"
                  tooltipPosition="bottom"
                  (onClick)="goToOrderDetailPage(order.importOrder.guid)"/>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</app-admin-dashboard>
